import {z} from 'zod';

// http://nemo.indigo/docs/index.html#req_4d6857e849cc4b5b9e3d96fa66e2df22
// http://nemo.indigo/docs/index.html#req_66eb280c9ff2453cb67deb4473fe3dd1
// http://nemo.indigo/docs/index.html#req_1c3162a714174d65aa20475eefdcd60b


export type SzumCredentials = {
    mapkey: string;
    username: string;
    password: string;
};


export const API_DataTypeSchema = z.enum(['int', 'double', 'bool', 'datetime', 'date','time', 'int_array', 'string_array', 'string', 'geometry', 'money']);
export type API_DataType = z.infer<typeof API_DataTypeSchema>;


export const API_ObjectAttributesSchema = z.object({
    name: z.string(),
    data_type: API_DataTypeSchema,
    alarm: z.boolean(),
    editable: z.boolean(),
    colorable: z.boolean(),
    filterable: z.boolean(),
    max: z.number().nullable(),
    min: z.number().nullable(),
    default_values: z.array(z.number().or(z.literal(false))).length(2).catch([false, false]),
    max_length: z.number().nullable(),
    reference: z.string().nullable(),
    unit: z.string().nullable(),
    filter_str: z.string().optional(),
    subtype: z.any().optional(),
    desc: z.string().optional(),
    info: z.string().optional(),
    period_range: z.object({
        min: z.string(),
        max: z.string(),
    }).optional().nullable(),
    collection: z.string().optional().nullable(),
    fld_period: z.string().optional().nullable(),
    can_be_related: z.boolean(),
    cluster: z.string().optional(),
    cluster_cfg: z.any().optional()
});
export type API_ObjectAttributesType = z.infer<typeof API_ObjectAttributesSchema>;

